module.exports = __webpack_public_path__ + "media/images/application/template/logos/fdq-4a17c499cfb138a5daf829157ef3f3c4.png";